class Location extends HTMLElement {
  constructor() {
    super();

    this.desktopLocation = document.querySelector("#PopupLocation");
    this.drawerLocation = document.querySelector("#DetailsDrawerLocation");
    this.locationLabel = document.querySelectorAll('.default_label');
    this.deliveryLabel = this.desktopLocation?.querySelector('.location_label');
    this.countryValue = document.querySelector('#country');
    this.zipcodeValue = document.querySelector('#zipcode');
    //this.languageValue = document.cookie.split("; ").find((row) => row.startsWith("translation-lab-lang="))?.split("=")[1];
    this.location = document.querySelector('#DetailsLocation');
    this.locationListItems = document.querySelectorAll("#DetailsLocationList button");
    this.error = document.querySelector("#DetailsError");
    this.submit = document.querySelector("#DetailsSubmit");
    this.close = document.querySelector("location-modal .modal__close-button");

    // Blog
     this.blogLink = document.querySelector("#footer-blogs");

    // Cookie versioning

    this.cookieOldVersion = 2;
    this.cookieVersion = 3;
    this.cookie_version = document.cookie.split("; ").find((row) => row.startsWith("cookie_version="))?.split("=")[1];

    if(!this.cookie_version){
      const COOKIE_VERSION_KEY = 'cookie_version';
      const expiresDate = new Date();
      expiresDate.setFullYear(expiresDate.getFullYear() + 10);
      const expires = `expires=${expiresDate.toUTCString()}; path=/`;
      document.cookie = `${COOKIE_VERSION_KEY}=${this.cookieVersion}; ${expires}`;
    }

    if(this.cookie_version != this.cookieVersion){
      document.cookie = `country=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `zipcode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }

    // --- Generic one-time forced reset based on country + zip rules (supports full-country) ---
    try {
      const getCookie = (name) =>
        document.cookie.split("; ").find(r => r.startsWith(name + "="))?.split("=")[1] || null;

      const resetVersion = getCookie("location_reset_version"); // e.g. "2026-02-13-1"
      const resetRulesRaw = getCookie("location_reset_rules");  // encoded JSON

      if (resetVersion && resetRulesRaw) {
        const appliedKey = `location_reset_applied_${resetVersion}`;
        const alreadyApplied = localStorage.getItem(appliedKey) === "1";

        if (!alreadyApplied) {
          const rulesJson = decodeURIComponent(resetRulesRaw);
          const rules = JSON.parse(rulesJson);

          // Read current user location from cookies
          const country = (getCookie("country") || "").toUpperCase();
          const zipcode = (getCookie("zipcode") || "").replace(/\s+/g, "");

          const ruleCountry = (rules.country || "").toUpperCase();

          // ✅ NEW: full-country reset support
          const allZipcodes = rules.all_zipcodes === true;

          // ✅ Zip list (optional)
          const zipList = Array.isArray(rules.zipcodes) ? rules.zipcodes : [];
          const zipSet = new Set(zipList.map(z => String(z).replace(/\s+/g, "")));

          // Match logic:
          // - Must match country
          // - If all_zipcodes=true => zip not required
          // - Else => must have zip and be in list
          const matchesRule =
            country &&
            country === ruleCountry &&
            (
              allZipcodes ||
              (zipcode && zipSet.size > 0 && zipSet.has(zipcode))
            );

          if (matchesRule) {
            // Clear only location cookies (forces modal/reroute via your existing logic)
            document.cookie = `country=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            document.cookie = `zipcode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          }

          // Run only once per browser per resetVersion
          localStorage.setItem(appliedKey, "1");
        }
      }
    } catch (e) {
      // Fail safely — do nothing
    }

  }

  connectedCallback() {
    this.getCountryValue =  null;
    this.getZipcodeValue = null;

    if (window.location.search) {
      this.params = new URLSearchParams(window.location.search);

      const hasCountry = this.params.has('countrycode');
      const hasZip = this.params.has('zipcode');

      if (hasCountry || hasZip) {
        this.getCountryValue = this.params.get('countrycode') || null;
        this.getZipcodeValue = this.params.get('zipcode') || null;

        this.setCookie({
          country: this.getCountryValue,
          zipcode: this.getZipcodeValue,
          version: this.cookieVersion,
        });
      } else {
        // fallback to cookies if query exists but without these keys
        this.getCountryValue = document.cookie
          .split('; ')
          .find((row) => row.startsWith('country='))?.split('=')[1].toUpperCase() || null;

        this.getZipcodeValue = document.cookie
          .split('; ')
          .find((row) => row.startsWith('zipcode='))?.split('=')[1] || null;
      }
    } else {
      // no search string at all → use cookies
      this.getCountryValue = document.cookie
        .split('; ')
        .find((row) => row.startsWith('country='))?.split('=')[1].toUpperCase() || null;

      this.getZipcodeValue = document.cookie
        .split('; ')
        .find((row) => row.startsWith('zipcode='))?.split('=')[1] || null;
    }

    if(!this.getCountryValue || !this.getZipcodeValue){
      if(!Shopify.designMode){
        this.desktopLocation.setAttribute('open', '');
      }
    }else{
      this.submit?.removeAttribute('disabled');
      this.close?.classList.remove('hidden');
    }

    if(this.getZipcodeValue){
      this.zipcodeValue.value = this.getZipcodeValue;
    }
    if(this.getCountryValue){
      this.locationListItems.forEach(button => {
        const buttonCountry = button.getAttribute("data-country");
        if (buttonCountry && buttonCountry === this.getCountryValue) {
          const locationValue = button.getAttribute("data-location");
          if (locationValue) {
            this.countryValue.value = locationValue;
            this.countryValue.setAttribute('data-country',buttonCountry);
            button.classList.add("list-menu__item--active");

            this.deliveryLabel?.classList.remove('hidden');
            this.locationLabel?.forEach(label => {
              label.textContent = `${this.getZipcodeValue}, ${locationValue}`;
            });

            if(Shopify.country !== 'DE') {
              this.blogLink?.setAttribute('href',`/blogs/${locationValue.toLowerCase()}`);
            }
          }
        }
      });
    }

    if (
      window.location.search &&
      document.cookie.split("; ").find(r => r.startsWith("country="))?.split("=")[1] &&
      document.cookie.split("; ").find(r => r.startsWith("zipcode="))?.split("=")[1]
    ) {
      const url = new URL(window.location.href);
      const params = url.searchParams;

      const hadCountry = params.has('countrycode');
      const hadZip = params.has('zipcode');

      if (hadCountry || hadZip) {
        params.delete('countrycode');
        params.delete('zipcode');

        // keep other params, path, and hash
        url.search = params.toString();
        const newUrl = url.pathname + (url.search ? `?${url.searchParams.toString()}` : '') + url.hash;

        window.history.replaceState(null, '', newUrl);
      }
    }

    if (!Shopify.designMode && this.getCountryValue && Shopify.country !== this.getCountryValue && this.getCountryValue !== 'CH') {
      console.log(this.getCountryValue, Shopify.country);
      setTimeout(() => {
        this.submit?.removeAttribute('disabled');
        this.submit?.click();
      }, 100);
    }

    this.drawerLocation?.addEventListener("click", () =>{
      this.desktopLocation.setAttribute('open', '');
      document.querySelector('#Details-menu-drawer-container summary').click();
    });

    this.locationListItems?.forEach((item) => item.addEventListener("click", this.onLocationClick.bind(this,item)));

    this.countryValue?.addEventListener("input", this.onInputChange.bind(this));
    this.zipcodeValue?.addEventListener("input", this.onInputChange.bind(this));

    this.submit?.addEventListener("click", this.onSubmitClick.bind(this));

  }

  showError(message) {
    if (!this.error) return;
    this.error.textContent = message;
    this.error.classList.remove('hidden');
  }

  clearError() {
    if (!this.error) return;
    this.error.textContent = '';
    this.error.classList.add('hidden');
  }

  setCookie({ country, zipcode, version = this.cookieOldVersion }) {
    const COOKIE_VERSION_KEY = 'cookie_version';
    const expiresDate = new Date();
    expiresDate.setFullYear(expiresDate.getFullYear() + 1);
    const expires = `expires=${expiresDate.toUTCString()}; path=/; SameSite=Lax`;
    const secureFlag = location.protocol === 'https:' ? '; Secure' : '';

    // Helper to get cookie value
    const getCookie = (name) => {
      return document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='))
        ?.split('=')[1] || null;
    };

    // Version check - clear old cookies if version changed
    const currentVersion = parseInt(getCookie(COOKIE_VERSION_KEY)) || 0;
    if (currentVersion !== version) {
      ['country', 'zipcode'].forEach(key => {
        document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;${secureFlag}`;
      });
    }

    // Set version cookie
    document.cookie = `${COOKIE_VERSION_KEY}=${version};${expires};${secureFlag}`;

    // Set data cookies + sync to localStorage
    if (country) {
      const countryValue = country;
      document.cookie = `country=${countryValue};${expires};${secureFlag}`;
      //localStorage.setItem('userCountry', countryValue); // Sync to localStorage
    }

    if (zipcode) {
      const zipcodeValue = zipcode;
      document.cookie = `zipcode=${zipcodeValue};${expires};${secureFlag}`;
      //localStorage.setItem('userZipcode', zipcodeValue); // Sync to localStorage
    }
  }


  updateLocalization(country) {
    const formId = crypto.randomUUID();
    const formHtml = `
      <form id="${formId}" action="/localization" method="POST" hidden>
        <input name="_method" value="PUT">
        <input name="country_code" value="${country}">
      </form>
    `;
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId)?.submit();

  }

  onLocationClick(item) {
    if(document.querySelector('.list-menu__item--active')){
      document.querySelector('.list-menu__item--active').classList.remove('list-menu__item--active');
    }
    item.classList.add('list-menu__item--active');
    this.countryValue.setAttribute('data-country', item.getAttribute('data-country'));
    this.countryValue.value = item.getAttribute('data-location');

    this.location.removeAttribute("open");
  }

  onInputChange() {
    const countryField = this.countryValue?.value.trim();
    const rawZip = this.zipcodeValue?.value || '';
    const zipcodeField = rawZip.trim();
    const pattern = /^[A-Za-z0-9\s\-]{3,10}$/; // 3–10 chars, letters/numbers/space/hyphen

    // If less than 3 chars: no error yet, just disable submit
    if (zipcodeField && zipcodeField.length < 3) {
      this.clearError();
      this.submit?.setAttribute('disabled', '');
      return;
    }

    const isZipValid = pattern.test(zipcodeField);

    // ZIP present (>=3 chars) but invalid
    if (zipcodeField && !isZipValid) {
      this.showError('Please enter a valid European postal code.');
      this.submit?.setAttribute('disabled', '');
      return;
    }

    // ZIP empty or valid
    this.clearError();

    // Enable submit only when both fields filled and ZIP valid
    if (countryField && zipcodeField && isZipValid) {
      this.submit?.removeAttribute('disabled');
      //this.close?.classList.remove('hidden');
    } else {
      this.submit?.setAttribute('disabled', '');
      //this.close?.classList.add('hidden');
    }
  }

  onSubmitClick(){
    const countryLabel = this.countryValue?.value;
    const countryValue = this.countryValue?.getAttribute("data-country");
    const zipcodeValue = this.zipcodeValue?.value;

    this.submit.classList.add('loading');
    this.submit.querySelector('.loading-overlay__spinner').classList.remove('hidden');


    const url = `https://europe-west3-dookan-internal.cloudfunctions.net/dookan_store_location_service/location?country=${countryValue}&zipcode=${zipcodeValue}`;
    const myHeaders = new Headers();
    myHeaders.append("Accept", "*/*");
    myHeaders.append("User-Agent", "Thunder Client (<https://www.thunderclient.com>)");
    myHeaders.append("Dookan-Token", "c59f728b42e7aa89de0a4c6cde949d06cc56f5fd0f120d89291acc0d4c04574309f12");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };
    fetch(url, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if(result.status == 'success'){
        //console.log(result.domain, Shopify.shop, result.markets, Shopify.country);
        
        // Custom Event For Country Selected Starts
        window.analytics?.publish("dookan_country_selected", {
          country: selectedCountry,
          postal_code: postalCode
        });
        // Custom Event For Country Selected Ends

        if(result.domain == Shopify.shop && result.markets != Shopify.country){
          if (countryValue === 'CH' && Shopify.country !== 'DE') {
           this.updateLocalization("DE");
          }else{
           this.updateLocalization(countryValue);
          }
        }else{
          if(window.location.search){
            window.location.href= `https://${result.domain}${window.location.pathname.replace('/cs','')}${window.location.search}&zipcode=${zipcodeValue}&countrycode=${countryValue}`;
          }else{
            window.location.href= `https://${result.domain}${window.location.pathname.replace('/cs','')}?zipcode=${zipcodeValue}&countrycode=${countryValue}`;
          }
        }
        this.deliveryLabel?.classList.remove('hidden');
        this.locationLabel?.forEach(label => {
          label.textContent = `${zipcodeValue}, ${countryLabel}`;
        });

        this.desktopLocation.removeAttribute('open');
        this.setCookie({ country: countryValue, zipcode: zipcodeValue, version: this.cookieVersion });

      } else {
        this.showError("Error verifying location. Please try again.");
      }
    })
    .catch((error) => {
      this.showError(error || error.message || "Error verifying location. Please try again.");
    })
    .finally(() => {
      this.submit.classList.remove('loading');
      this.submit.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });


  }

}
customElements.define("location-modal", Location);